<!-- 关联实体 -->
<template>
  <div v-loading="loading">
    <div class="container">
      <div class="containerBox">
        <div class="search">
          <div class="searchBox">
            <span class="searchtitle">{{
              source == 1 ? "客户" : "供应商"
            }}</span>
            <el-select
              v-if="source == 1"
              class="vin-input"
              v-model="entpCusId"
              filterable
              clearable
              placeholder="选择客户"
              remote
              reserve-keyword
              :remote-method="searchCustomer"
              @visible-change="customerVisibleChange($event)"
              @change="cusChange"
            >
              <el-option
                v-for="optionItem in customerList"
                :key="optionItem.EntpCusId"
                :data-msg="optionItem"
                :label="optionItem.EntpCusName"
                :value="optionItem.EntpCusId"
              ></el-option>
            </el-select>
            <el-select
              v-else
              class="vin-input"
              v-model="entpCusId"
              filterable
              clearable
              remote
              reserve-keyword
              @visible-change="supVisibleChange($event)"
              placeholder="选择供应商"
              @change="cusChange"
            >
              <el-option
                v-for="optionItem in customerList"
                :key="optionItem.EntpCusId"
                :data-msg="optionItem"
                :label="optionItem.EntpCusName"
                :value="optionItem.EntpCusId"
              ></el-option>
            </el-select>
            <el-button
              class="btn-primary"
              @click="releEntpData"
              :disabled="isRele"
              >关联</el-button
            >
          </div>
        </div>
        <div class="search-result" v-if="!isNonResult">
          <div class="result-row">
            <div class="result-cell">
              <div class="key">
                {{ source == 1 ? "客户名称" : "供应商名称" }}
              </div>
              <div class="value">
                <el-badge value="已有关联" v-if="isRele">
                  <span>{{ cusData.Name }}</span>
                </el-badge>
                <span v-else>{{ cusData.Name }}</span>
              </div>
            </div>
            <div class="result-cell">
              <div class="key">微信</div>
              <div class="value">
                <span>{{ cusData.WeChat }}</span>
              </div>
            </div>
            <div class="result-cell">
              <div class="key">主营配件</div>
              <div class="value">
                <span>{{ cusData.MainPartName }}</span>
              </div>
            </div>
          </div>
          <div class="result-row">
            <div class="result-cell">
              <div class="key">标签</div>
              <div class="value">
                <span>{{ cusData.Tags }}</span>
              </div>
            </div>
            <div class="result-cell">
              <div class="key">社媒号</div>
              <div class="value">
                <span>{{ cusData.Payment }}</span>
              </div>
            </div>
            <div class="result-cell">
              <div class="key">主营车型</div>
              <div class="value">
                <span>{{ cusData.MainVehicle }}</span>
              </div>
            </div>
          </div>
          <div class="result-row">
            <div class="result-cell">
              <div class="key">所属国家</div>
              <div class="value">
                <span>{{ cusData.Country }}</span>
              </div>
            </div>
            <div class="result-cell">
              <div class="key">电子邮箱</div>
              <div class="value">
                <span>{{ cusData.Email }}</span>
              </div>
            </div>
            <div class="result-cell">
              <div class="key">其他联系人</div>
              <div class="value">
                <span>{{ cusData.Contactor }}</span>
              </div>
            </div>
          </div>
          <div class="result-row">
            <div class="result-cell">
              <div class="key">手机号</div>
              <div class="value">
                <span>{{ cusData.CallNum }}</span>
              </div>
            </div>
            <div class="result-cell">
              <div class="key">邮编</div>
              <div class="value">
                <span>{{ cusData.Zipcode }}</span>
              </div>
            </div>
            <div class="result-cell">
              <div class="key">联系人电话</div>
              <div class="value">
                <span>{{ cusData.PhoneNum }}</span>
              </div>
            </div>
          </div>
          <div class="result-row">
            <div class="result-cell">
              <div class="key">QQ</div>
              <div class="value">
                <span>{{ cusData.Qq }}</span>
              </div>
            </div>
            <div class="result-cell">
              <div class="key">网址</div>
              <div class="value">
                <span>{{ cusData.Website }}</span>
              </div>
            </div>
            <div class="result-cell">
              <div class="key">职位</div>
              <div class="value">
                <span>{{ cusData.Position }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["releEntpId", "source"], //1 客户，2 供应商
  data() {
    return {
      loading: false,
      cusName: "",
      cusData: {},
      customerList: [],
      isNonResult: false,
      entpCusId: "",
      isRele: false,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      this.loading = true;

      this.$util
        .axiosGet({
          url: "/api/EntpUnions/GetReleEntpData",
          data: {
            ReleEntpId: this.releEntpId,
            EntpType: this.source == 1 ? 0 : 1,
          },
          hideLoading: true,
        })
        .then((res) => {
          if (res.data) {
            this.cusData = res.data.CusData;
            this.isRele = res.data.IsRele;
            this.isNonResult = false;
          } else this.isNonResult = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cusChange() {
      this.$util
        .axiosGet({
          url: "/api/EntpUnions/GetEntpCusData",
          data: {
            EntpCusId: this.entpCusId,
          },
          hideLoading: true,
        })
        .then((res) => {
          if (res.data) {
            this.cusData = res.data.CusData;
            this.isRele = res.data.IsRele;
            this.isNonResult = false;
          } else this.isNonResult = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    releEntpData() {
      let that = this;
      that
        .$confirm("确定要关联企业信息吗", "提示", {
          confirmButtonText: "确定关联",
          cancelButtonText: "先不关联",
          type: "warning",
          center: false,
        })
        .then(() => {
          that.loading = true;
          that.$util
            .axiosPost({
              url: "/api/EntpUnions/ReleEnterpriseEntity",
              data: {
                ReleEntpId: this.releEntpId,
                EntpCusId: this.entpCusId,
                EntpType: this.source == 1 ? 0 : 1,
              },
              hideLoading: true,
            })
            .then(() => {
              that.$util.successMsg("成功关联企业信息");
              that.$emit("closeDialog", true);
            })
            .finally(() => {
              that.loading = false;
            });
        })
        .catch(() => {});
    },
    customerVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.EntpCusId && !that.searchData.EntpCusId) {
          if (that.customerList.length == 1) that.searchCustomer('');
        } else {
          if (that.customerList.length == 0) that.searchCustomer('');
        }
      }
    },
    supVisibleChange(event) {
      let that = this;
      if (event) {
        if (that.customerList.length == 0) that.searchSup('');
      }
    },
    searchCustomer(key) {
      this.$util
        .searchCustomer(key)
        .then((data) => {
          this.customerList = data;
        })
        .catch(() => {});
    },
    searchSup(key) {
      this.$util
        .searchSupplier(key)
        .then((data) => {
          this.customerList = data;
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="less" scoped>
.searchtitle {
  font-size: 18px;
  font-weight: bold;
  margin-right: 5px;
}
.search-result {
  width: 900px;
  margin: 0 auto;
  padding-top: 30px;
  border-bottom: 1px solid #dcdfe6;

  .result-row {
    display: flex;
    border-right: 1px solid #dcdfe6;
  }
  .result-cell {
    width: 50%;
    display: flex;
    align-items: center;
    border-top: 1px solid #dcdfe6;

    .key {
      height: 50px;
      line-height: 50px;
      width: 100px;
      text-align: center;
      background-color: #f2f6fc;
      border-left: 1px solid #dcdfe6;
      padding-right: 10px;
    }
    .value {
      width: 200px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      border-left: 1px solid #dcdfe6;
    }
  }
}
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  height: 400px;
}
.containerBox {
  margin-top: 30px;
  width: 1440px;
}
.search {
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.searchHistory {
  display: inline-flex;
  flex-flow: row-reverse;
}
.searchBox {
  width: 80%;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: center;
  .vin-input {
    width: 400px;
    padding-right: 5px;
  }
}
</style>